<template>
  <div>
    <p class="ma-0 font-13">
      <span class="font-weight-medium">Formato do arquivo:</span>
      <span class="pl-1 text-azul-link text-decoration-underline cursor-pointer" @click="dialog_ativo = ! dialog_ativo">baixar modelo</span>
    </p>

    <v-dialog v-model="dialog_ativo" persistent content-class="bra-20" width="600" transition="dialog-top-transition">
      <v-card>
        <v-card-title class="py-5">
          <span>Importação arquivo</span>

          <v-spacer />

          <v-btn icon @click="dialog_ativo = ! dialog_ativo">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pl-6 pr-4 pb-0 pt-1">
          <SysFornecedorAutocomplete
            v-model="filtros.fornecedores"
            label="Fornecedores"
            outlined
            multiple
            :qtde-visivel-selecionados="15"
            class="mr-2"
            clearable
          />
        </v-card-text>

        <div class="d-flex px-3 pb-3 mt-n2">
          <v-spacer />
          <v-btn text color="primary" @click="baixarArquivo">baixar arquivo</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete";
import $axios from "@/api/api";

export default {
  name: "BaixarModeloArquivo",
  components: {
    SysFornecedorAutocomplete
  },
  data: () => ({
    dialog_ativo:  false,
    filtros: {
      fornecedores: []
    }
  }),
  watch: {
    dialog_ativo() {
      if (!this.dialog_ativo) {
        this.filtros.fornecedores = [];
      }
    }
  },
  methods: {
    baixarArquivo() {
      let url = `${$axios.defaults.baseURL}/download-modelo-importacao-curvas-criticidade`;
      url += `?fornecedores=${(this.filtros.fornecedores || []).toString()}`;
      window.open(url, "_blank");
      this.dialog_ativo = false;
    }
  }
}
</script>

<style scoped>
.text-azul-link {
  color: #077ce7;
}
</style>
